// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React from 'react'; /* eslint-disable-line no-unused-vars */
import { isEqual } from 'lodash';

import ToggleButton from '../ToggleButton';
import { Colors } from '@zapier/theme';
import { css, jsx } from '@emotion/core';

/** @jsx jsx */

const toggleButtonGroupCss = css({
  border: `1px solid ${Colors.adamantium}`,
  borderRadius: '4px',
  display: 'inline-flex',
  overflow: 'hidden',
});

type Props = {
  /** Handle value changes */
  onChange: ({ key: string, label?: string, value: number }) => void,
  /**
   * Array of options
   * ```
   * {
   *  key: display text,
   *  value: value sent in onClick
   * }
   * ```
   */
  options: Array<{ key: string, label?: string, value: number }>,
  /** Current value */
  value: any,
};

/**
 * A grouping of ToggleButtons where only one can be selected at a time
 */
const ToggleButtonGroup = ({ onChange, options, value }: Props) => {
  if (!Array.isArray(options) || options.length === 0) return null;
  const inner = options.map((option, i) => (
    <ToggleButton
      isSelected={isEqual(option.value, value)}
      key={`${i}_${option.key}`}
      onClick={() => onChange(option)}
      value={option.value}
    >
      {option.key}
    </ToggleButton>
  ));

  return <div css={toggleButtonGroupCss}>{inner}</div>;
};

export default ToggleButtonGroup;
